import { ReactElement } from "react";
import Chart from "../../components/charts/chart";
import { getTicks, useChartDimensions, useUniqueId } from "../../components/charts/chartUtils";
import * as d3 from "d3";
import AxisHorizontal from "../../components/charts/AxisHorizontal";
import { IDelayBase, ISchemaNode } from "../../types";
import {
  formatDateTimeWithSeconds,
  formatTimeWithSeconds,
  getCurrentDatetimeInSeconds
} from "../../system/utils";
import { getPalette } from "../../configuration/configuration";
import DelayLayerGantt from "./compoenents/delayLayerGantt";

interface IInterruptionChartProps {
  beginShift: number;
  endShift?: number;
  title: string | number;
  delays: IDelayBase[];
  selected?: IDelayBase | null;
  setSelected?: (row: IDelayBase | null) => void;
  machines?: ISchemaNode[] | null;
  selectedMachine: string | null;
}


const InterruptionChart = ({ beginShift, endShift, delays, selected, setSelected, title, machines, selectedMachine }: IInterruptionChartProps): ReactElement => {
  const [ref, dimensions] = useChartDimensions<HTMLDivElement>({
    height: 120,
    marginBottom: 60,
    marginLeft: 30,
    marginRight: 30,
    marginTop: 20
  });

  const chartID = useUniqueId("delay-chart");

  const xScale = d3.scaleLinear()
    .domain([beginShift, endShift ?? getCurrentDatetimeInSeconds()])
    .range([0, dimensions.boundedWidth]);

  const xAccessorScaled = (d: IDelayBase) => xScale(d.beginDatetime);
  const widthAccessorScaled = (d: IDelayBase) => xScale(d.endDatetime ?? getCurrentDatetimeInSeconds()) - xScale(d.beginDatetime);

  const machineList = machines ? machines.filter(x => !selectedMachine || x.code === selectedMachine).map(y => y.code) : [ selectedMachine ];
  const machineHeight = dimensions.boundedHeight / machineList.length;

  return (
    <div ref={ref}>
      <Chart dimensions={dimensions}  >
        <defs>
          <clipPath id="cut-off">
            <rect x="0" y="0" width={dimensions.boundedWidth} height={dimensions.boundedHeight} />
          </clipPath>
        </defs>

        <AxisHorizontal
          chartID={chartID}
          dimensions={dimensions}
          scale={xScale}
          label={`${title}`}
          ticks={getTicks(xScale.domain(), 5)}
          formatTick={(value, index) => index === 0 || index === 4 ? formatDateTimeWithSeconds(value as number) : formatTimeWithSeconds(value as number)}/>

        <rect
          style={{ fill: getPalette().statusColor.production.background }}
          x={0}
          y={0}
          width={dimensions.boundedWidth}
          height={dimensions.boundedHeight - 2} />

        { machineList.map((machine, index) =>
          <DelayLayerGantt key={`DelayLayerGantt-${machine}`} delays={delays.filter(x => x.production?.machine.code === machine)}
            height={machineHeight - 2} y={index * machineHeight} xAccessorScaled={xAccessorScaled}
            widthAccessorScaled={widthAccessorScaled} selected={selected} chartKey={chartID} setSelected={setSelected} />
        )
        }

      </Chart>
    </div>
  );
};

export default InterruptionChart;
